import { ReactNode } from 'react';

import {
  CLOSET_PATH,
  FLOOR_PATH,
  HANDING_PATH,
  LED_MIRRORS_PATH,
  MIRROR_CABINETS_PATH,
  MIRRORS_PATH,
  PEDESTAL_PATH,
  UNDER_WASHING_MACHINE_PATH
} from '@shared/constants/catalog';

export type SubCategorySeoPathType = {
  text: ReactNode;
};

type CategorySeoPathType = SubCategorySeoPathType & {
  subcategories: Record<string, SubCategorySeoPathType>;
};

export const SEO_PATH: Record<string, CategorySeoPathType> = {
  [PEDESTAL_PATH]: {
    text: (
      <>
        <p>
          В каталоге Olevaro представлен широкий выбор тумб под раковину для ванной комнаты — стильных, удобных и
          долговечных. Мы производим мебель, которая сочетает современный дизайн, влагостойкие материалы и продуманную
          функциональность.
        </p>
        <p>У нас вы можете купить тумбу под раковину в ванную комнату любого формата:</p>
        <ul>
          <li>
            <b>напольные тумбы</b> — устойчивые и вместительные, отлично подходят для хранения бытовой химии и текстиля;
          </li>
          <li>
            <b>подвесные тумбы</b> — создают ощущение лёгкости и визуально увеличивают пространство ванной;
          </li>
          <li>
            <b>тумбы под стиральную машину</b> — помогают рационально использовать каждый сантиметр комнаты, сохраняя
            порядок и эстетику.
          </li>
        </ul>
        <p>
          Все модели комплектуются качественной фурнитурой и устойчивы к влаге, что особенно важно для помещений с
          повышенной влажностью.
        </p>
        <p>
          Если вы ищете, где купить тумбочку под раковину в ванную комнату, обратите внимание на продукцию Olevaro. Мы
          предлагаем мебель, разработанную с учётом реальных потребностей — от компактных решений для небольших санузлов
          до просторных моделей для больших ванных.
        </p>
        <p>Преимущества тумб Olevaro:</p>
        <ul>
          <li>влагостойкие материалы и надежное покрытие;</li>
          <li>удобные системы хранения;</li>
          <li>аккуратная подгонка под раковину и сантехнику;</li>
          <li>современный дизайн, подходящий к любому интерьеру.</li>
        </ul>
        <p>
          Заказать тумбу для ванной комнаты можно прямо на сайте: выберите модель в каталоге, добавьте в корзину и
          оформите покупку онлайн. Olevaro — это качественная мебель для ванной от производителя, с доставкой по всей
          России.
        </p>
      </>
    ),
    subcategories: {
      [HANDING_PATH]: {
        text: (
          <>
            <p>
              <b>Подвесные тумбы для ванной комнаты</b> — идеальное решение для тех, кто ценит современный дизайн,
              удобство уборки и визуальную лёгкость пространства. В каталоге Olevaro представлены навесные и подвесные
              тумбы под раковину, созданные специально для ванных комнат любого размера и стиля.
            </p>
            <p>
              У нас вы можете купить подвесную тумбу под раковину с раковиной, с выдвижными ящиками или распашными
              дверцами. Все модели производятся из влагостойких материалов, устойчивых к перепадам температуры и
              влажности.
            </p>
            <p>
              <b>Преимущества подвесных тумб Olevaro:</b>
            </p>
            <ul>
              <li>визуально увеличивают пространство ванной комнаты;</li>
              <li>упрощают уборку пола — ничего не мешает под тумбой;</li>
              <li>подходят под разные типы раковин и умывальников;</li>
              <li>оснащены надежной фурнитурой и мягким закрыванием;</li>
              <li> имеют лаконичный современный дизайн.</li>
            </ul>
            <p>
              Наши навесные тумбы под раковину для ванной комнаты выпускаются в разных цветах и размерах — от компактных
              моделей для небольших санузлов до широких решений с раковиной и вместительными ящиками.
            </p>
            <p>
              Если вы ищете, где купить подвесную тумбу в ванную комнату напрямую от производителя, выбирайте Olevaro.
              Мы предлагаем стильную, качественную и функциональную мебель с доставкой по всей России.
            </p>
            <p>
              Закажите тумбу подвесную в ванную в нашем интернет-магазине — и создайте чистое, современное и удобное
              пространство, где каждая деталь продумана до мелочей.
            </p>
          </>
        )
      },
      [FLOOR_PATH]: {
        text: (
          <>
            <p>
              <b>Напольные тумбы для ванной комнаты</b> — это практичное и надёжное решение для хранения, которое
              подходит для ванных любого размера. В каталоге Olevaro вы найдёте тумбы с раковиной, с выдвижными ящиками
              или дверцами, выполненные в разных стилях и цветовых решениях.
            </p>
            <p>
              У нас можно купить напольную тумбу в ванную комнату напрямую от производителя — без наценок и посредников.
              Каждая модель сочетает в себе функциональность, влагостойкость и современный дизайн.
            </p>
            <p>Преимущества напольных тумб Olevaro:</p>
            <ul>
              <li>устойчивость и надёжность конструкции;</li>
              <li>удобные системы хранения — ящики, полки, корзины;</li>
              <li>влагостойкие материалы, защищённые от деформации;</li>
              <li>разнообразие размеров и форматов: от компактных моделей до просторных решений с раковиной.</li>
            </ul>
            <p>
              Напольные тумбы под раковину для ванной комнаты идеально подойдут тем, кто предпочитает классическую
              установку мебели и хочет максимизировать пространство для хранения.
            </p>
            <p>
              Если вы ищете, где купить напольную тумбу с раковиной в ванную комнату, обратите внимание на продукцию
              Olevaro. Мы производим мебель, которая сохраняет внешний вид и функциональность даже при постоянной
              влажности.
            </p>
            <p>
              Закажите тумбу напольную для ванной в интернет-магазине Olevaro — и создайте удобное, гармоничное
              пространство, в котором каждая деталь продумана до мелочей.
            </p>
          </>
        )
      },
      [UNDER_WASHING_MACHINE_PATH]: {
        text: (
          <>
            <p>
              <b>Тумбы под стиральную машину</b> — это практичное решение для тех, кто хочет грамотно организовать
              пространство ванной комнаты. Мебель такого типа позволяет скрыть коммуникации, создать единую рабочую
              поверхность и гармонично вписать бытовую технику в интерьер.
            </p>
            <p>
              В каталоге Olevaro представлены тумбы для стиральной машины, рассчитанные на стандартные размеры бытовой
              техники. Конструкция продумана таким образом, чтобы обеспечить удобный доступ к раковине и стиральной
              машине, сохраняя эстетичный внешний вид ванной комнаты.
            </p>
            <p>Преимущества тумб под стиральную машину Olevaro:</p>
            <ul>
              <li>влагостойкие материалы, устойчивые к перепадам температуры;</li>
              <li>аккуратное совмещение раковины и техники в едином корпусе;</li>
              <li>дополнительные полки и ящики для хранения бытовых мелочей;</li>
              <li>современный лаконичный дизайн, подходящий к любому интерьеру.</li>
            </ul>
            <p>
              У нас вы можете купить тумбу под раковину и стиральную машину различных форматов. Если вы ищете, где
              купить тумбу для стиральной машины в ванную комнату, выберите продукцию Olevaro — мебель от производителя,
              созданную для функционального и стильного интерьера.
            </p>
            <p>
              Закажите тумбу с раковиной под стиральную машину в интернет-магазине Olevaro и оцените, насколько удобно и
              красиво может быть оформлено пространство ванной комнаты.
            </p>
          </>
        )
      }
    }
  },
  [CLOSET_PATH]: {
    text: (
      <>
        <p>
          <b>Шкафы для ванной комнаты</b> — это практичное решение для тех, кто ценит порядок и удобство хранения. Они
          помогают рационально использовать пространство, спрятать бытовую химию и косметику, а также добавить интерьеру
          аккуратный, завершённый вид.
        </p>
        <p>
          В каталоге Olevaro вы найдёте высокие шкафы, пеналы и напольные шкафы для ванной комнаты, выполненные из
          влагостойких материалов и оснащённые надёжной фурнитурой. Каждый элемент мебели продуман до мелочей, чтобы
          обеспечить долговечность и комфорт в использовании.
        </p>
        <p>Преимущества шкафов для ванной Olevaro:</p>
        <ul>
          <li>влагостойкие фасады, устойчивые к перепадам температуры;</li>
          <li>плавное и бесшумное открывание дверей;</li>
          <li> вместительные полки и ящики для хранения;</li>
          <li> разнообразие размеров — от компактных шкафчиков до высоких пеналов;</li>
          <li>современный дизайн, подходящий для любого интерьера.</li>
        </ul>
        <p>
          Если вы ищете, где купить шкаф пенал в ванную комнату, обратите внимание на продукцию Olevaro — мебель от
          производителя, созданную с учётом особенностей помещений с повышенной влажностью.
        </p>
        <p>
          Закажите шкаф или пенал для ванной комнаты в интернет-магазине Olevaro и создайте стильное, функциональное
          пространство, где всё находится на своём месте.
        </p>
      </>
    ),
    subcategories: {
      [HANDING_PATH]: {
        text: (
          <>
            <p>
              <b>Подвесные шкафы для ванной комнаты</b> — идеальный выбор для тех, кто ценит функциональность, стиль и
              визуальную лёгкость интерьера. Такая мебель не занимает место на полу, облегчает уборку и визуально
              увеличивает пространство, что особенно актуально для небольших ванных комнат и санузлов.
            </p>
            <p>
              В каталоге Olevaro представлены навесные и подвесные шкафы, шкафчики и пеналы для ванной комнаты разных
              размеров и конфигураций. Мы используем влагостойкие материалы и надёжную фурнитуру, чтобы мебель сохраняла
              прочность и внешний вид даже при постоянной влажности.
            </p>
            <p>Преимущества подвесных шкафов Olevaro:</p>
            <ul>
              <li>экономия пространства и лёгкий доступ ко всем зонам ванной;</li>
              <li>удобное хранение косметики, текстиля и бытовых принадлежностей;</li>
              <li>безопасное крепление и устойчивая конструкция;</li>
              <li>современный дизайн, подходящий как для лаконичных, так и для классических интерьеров.</li>
            </ul>
            <p>
              Если вы ищете, где купить подвесной шкаф в ванную комнату, выберите Olevaro — производителя, который
              сочетает дизайн, удобство и долговечность.
            </p>
            <p>
              Закажите навесной шкаф или шкафчик для ванной комнаты в интернет-магазине Olevaro и создайте
              функциональное и эстетичное пространство, где каждая деталь продумана до мелочей.
            </p>
          </>
        )
      },
      [FLOOR_PATH]: {
        text: (
          <>
            <p>
              <b>Напольные шкафы для ванной комнаты</b> — это практичное решение для организации хранения и создания
              уютного, аккуратного интерьера. Такая мебель обеспечивает устойчивость, вместительность и лёгкий доступ ко
              всем необходимым вещам.
            </p>
            <p>
              В каталоге Olevaro представлены напольные шкафы и пеналы различных размеров и конфигураций — от компактных
              колонок до высоких моделей для просторных ванных комнат. Все изделия производятся из влагостойких
              материалов, устойчивых к перепадам температуры и повышенной влажности.
            </p>
            <p>Преимущества напольных шкафов Olevaro:</p>
            <ul>
              <li>надёжная конструкция и устойчивая установка без необходимости крепления к стене;</li>
              <li>продуманная внутренняя организация — полки, ящики, корзины для хранения;</li>
              <li>качественная фурнитура, обеспечивающая плавное и тихое открывание;</li>
              <li>лаконичный современный дизайн, подходящий для любого стиля интерьера.</li>
            </ul>
            <p>
              Если вы ищете, где купить напольный шкаф или пенал для ванной комнаты, выбирайте Olevaro — производителя
              качественной мебели, сочетающей стиль, надёжность и функциональность.
            </p>
            <p>
              Закажите напольный шкаф-пенал для ванной комнаты в интернет-магазине Olevaro и создайте удобное,
              эстетичное пространство, где каждая деталь продумана до мелочей.
            </p>
          </>
        )
      },
      [UNDER_WASHING_MACHINE_PATH]: {
        text: (
          <>
            <p>
              <b> Шкафы под стиральную машину</b> — это удобное и функциональное решение для организации пространства в
              ванной комнате. Такая мебель помогает скрыть коммуникации, разместить бытовые принадлежности и сделать
              интерьер аккуратным и завершённым.
            </p>
            <p>
              В каталоге Olevaro представлены шкафы и пеналы под стиральную машину разных типов: напольные, навесные и
              комбинированные. Каждый элемент разработан с учётом стандартных размеров стиральных машин и особенностей
              помещений с повышенной влажностью.
            </p>
            <p>Преимущества шкафов под стиральную машину Olevaro: </p>
            <ul>
              <li>влагостойкие материалы, устойчивые к перепадам температуры и пару;</li>
              <li>точная подгонка под стандартные модели стиральных машин;</li>
              <li>наличие полок, ящиков и ниш для хранения бытовой химии, полотенец и аксессуаров;</li>
              <li>аккуратная интеграция техники в мебельный ансамбль ванной комнаты;</li>
              <li>современный дизайн, гармонично сочетающийся с тумбами, зеркалами и шкафами Olevaro.</li>
            </ul>
            <p>
              Если вы ищете, где купить шкаф под стиральную машину в ванную комнату, выберите продукцию Olevaro — мебель
              от производителя, созданную с вниманием к функциональности, надёжности и эстетике.
            </p>
            <p>
              Закажите шкаф над стиральной машиной или шкаф-пенал для стиральной машины в интернет-магазине Olevaro и
              создайте стильное и удобное пространство, где каждая зона продумана до мелочей.
            </p>
          </>
        )
      }
    }
  },
  [MIRRORS_PATH]: {
    text: (
      <>
        <p>
          <b>Зеркало для ванной комнаты</b> — неотъемлемый элемент современного интерьера, который делает утренние и
          вечерние процедуры комфортнее, а пространство — светлее и визуально больше. В каталоге Olevaro представлены
          зеркала для ванной комнаты разных форм, размеров и дизайнов.
        </p>
        <p>
          У нас вы можете купить зеркало в ванную комнату напрямую от производителя. Все модели созданы с учётом условий
          повышенной влажности и оснащены влагостойкими материалами, что гарантирует долговечность и сохранение внешнего
          вида.
        </p>
        <p>
          <b>В ассортименте зеркал Olevaro:</b>
        </p>
        <ul>
          <li>
            <b>зеркала с фронтальной подсветкой</b> — обеспечивают яркое и равномерное освещение лица, идеально подходят
            для ухода и макияжа;
          </li>
          <li>
            <b>зеркала с подсветкой за зеркалом</b> — создают мягкое рассеянное свечение, добавляя ванной уют и
            визуальный объём;
          </li>
          <li>
            <b>круглые и овальные зеркала</b> — стильный акцент, подходящий для современных интерьеров;
          </li>
          <li>
            <b>прямоугольные и квадратные зеркала</b> — универсальное решение для ванных комнат любого размера;
          </li>
          <li>
            <b>зеркала с функцией антизапотевания</b> — всегда остаются прозрачными, даже после горячего душа;
          </li>
          <li>
            <b>зеркала с бесконтактным включением подсветки</b> — включаются лёгким движением руки, без кнопок и следов
            на поверхности;
          </li>
          <li>
            <b>зеркала с диммером</b> — позволяют регулировать яркость подсветки в зависимости от времени суток и ваших
            предпочтений.
          </li>
        </ul>
        <p>
          Наши зеркала для ванной комнаты идеально сочетаются с мебелью из других коллекций Olevaro — тумбами, шкафами и
          пеналами, образуя единый гармоничный комплект.
        </p>
        <p>
          Если вы ищете, где купить зеркало для ванной комнаты с доставкой по России, выбирайте Olevaro. Мы предлагаем
          качественные и стильные зеркала, которые подчеркнут индивидуальность вашей ванной и прослужат долгие годы.
        </p>
        <p>
          Закажите зеркало в ванную в интернет-магазине Olevaro — и создайте пространство, где комфорт и эстетика
          сочетаются в каждой детали.
        </p>
      </>
    ),
    subcategories: {
      [LED_MIRRORS_PATH]: {
        text: (
          <>
            <p>
              <b>Зеркала с подсветкой для ванной комнаты</b> — это сочетание функциональности, стиля и современных
              технологий. Они делают ежедневные процедуры удобнее, создают комфортное освещение и придают интерьеру
              ванной особую атмосферу.
            </p>
            <p>
              В каталоге Olevaro вы найдёте зеркала в ванную с подсветкой разных форматов и дизайнов — от компактных
              настенных моделей до больших зеркал во всю стену. Все изделия создаются из влагостойких материалов и
              комплектуются надёжной электроникой, рассчитанной на использование во влажных помещениях.
            </p>
            <p>В ассортименте зеркал с подсветкой Olevaro:</p>
            <ul>
              <li>
                зеркала с фронтальной подсветкой — дают ровное и яркое освещение лица, идеально подходят для макияжа и
                бритья;
              </li>
              <li>
                зеркала с подсветкой за зеркалом (контурной) — создают мягкое декоративное свечение и визуально
                расширяют пространство;
              </li>
              <li>модели с регулировкой яркости (диммером) — позволяют выбрать оптимальный уровень освещения;</li>
              <li>зеркала с бесконтактным управлением — включаются лёгким движением руки, без следов и кнопок;</li>
              <li>зеркала с функцией антизапотевания — остаются идеально прозрачными даже после горячего душа;</li>
              <li>
                разные формы на выбор — круглые, овальные, прямоугольные и квадратные, чтобы идеально вписаться в
                интерьер вашей ванной.
              </li>
            </ul>
            <p>
              Зеркала для ванной комнаты с подсветкой Olevaro не только украшают помещение, но и делают его визуально
              просторнее и светлее. Они идеально сочетаются с мебелью Olevaro — тумбами, шкафами и пеналами, создавая
              единый гармоничный комплект.
            </p>
            <p>
              Если вы ищете, где купить зеркало с подсветкой в ванную комнату, выберите продукцию Olevaro — мебель и
              зеркала от производителя, разработанные с вниманием к каждой детали.
            </p>
            <p>
              Оформите заказ в нашем интернет-магазине зеркал для ванной комнаты и создайте пространство, где комфорт и
              стиль сочетаются с передовыми технологиями.
            </p>
          </>
        )
      },
      [MIRROR_CABINETS_PATH]: {
        text: (
          <>
            <p>
              <b>Зеркальные шкафы для ванной комнаты</b> — это удобное и функциональное решение, которое сочетает
              зеркало и систему хранения в одном корпусе. Такая мебель помогает поддерживать порядок, экономить место и
              придаёт интерьеру ванной завершённый вид.
            </p>
            <p>
              В каталоге Olevaro представлены зеркальные шкафы и шкафчики с зеркалом в ванную комнату разных размеров и
              конфигураций — от компактных моделей для небольших санузлов до вместительных шкафов с несколькими
              отделениями.
            </p>
            <p>Преимущества зеркальных шкафов Olevaro:</p>
            <ul>
              <li>влагостойкие материалы и надёжная фурнитура;</li>
              <li>встроенные зеркальные фасады, устойчивые к запотеванию;</li>
              <li> эргономичные полки и ящики для хранения косметики, аксессуаров и бытовой химии;</li>
              <li> возможность выбора расположения дверец и системы открывания;</li>
              <li>современный дизайн, который гармонично сочетается с другими элементами мебели Olevaro.</li>
            </ul>
            <p>
              Если вы ищете, где купить зеркальный шкаф в ванную комнату, выберите Olevaro — производителя качественной
              и продуманной мебели для ванных комнат. Мы предлагаем широкий выбор моделей, удобное онлайн-оформление и
              доставку по всей России.
            </p>
            <p>
              Закажите зеркальный шкафчик для ванной в интернет-магазине Olevaro — и создайте пространство, где каждая
              деталь сочетает эстетику и функциональность.
            </p>
          </>
        )
      }
    }
  }
};
